<template>
  <v-app>
 

  <!-- Sizes your content based upon application components -->
  <v-main  style="background-color:#F3F3F4" >
                   
      
        <v-container  fill-height >

          <!-- <v-card outlined style="background-color:#F3F3F4" > -->
           <v-container   >
             <form role="form" @submit.prevent="register" >
              <v-row>
                
                  <v-col              
                  cols="12"
                  md="12"
                  align="center"
                  justify="center"
                >
                  <v-img                
                    max-height="100"
                    max-width="150"
                    width="150"
                  src="logo3mm.png"
                  ></v-img>
                </v-col>
              </v-row>


              <v-row  align="center"
                  justify="center">
              
                <v-col              
                  :md="colunas"   
                  align="center"
                  justify="center"
                  style="color:#627AAD"        
                >
                <strong> {{nameApp}} </strong>
                </v-col>
              </v-row>


              <v-row  align="center" justify="center">
              
                <v-col              
                  :md="colunas"   
                  align="center"
                  justify="center"                     
                >
                 Cadastre-se
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      ref="name"
                      label="Nome"
                      placeholder="Nome"                      
                      @change="$v.data.name.$touch()"                      
                      v-model="data.name"
                      persistent-hint hint="Campo obrigatório"
                      maxlength="100"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field                      
                      label="Email"
                      placeholder="Email"                      
                      @change="$v.data.email.$touch()"                      
                      v-model="data.email"
                      persistent-hint hint="Campo obrigatório"
                      maxlength="100"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="Senha"
                      placeholder="Senha"                      
                      @change="$v.data.password.$touch()"                      
                      v-model="data.password"
                      type="password"
                      persistent-hint hint="Campo obrigatório"
                      maxlength="50"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="Repita a Senha"
                      placeholder="Repita a Senha"                      
                      @change="$v.data.password_again.$touch()"                      
                      v-model="data.password_again"
                      type="password"
                      persistent-hint hint="Campo obrigatório"
                      maxlength="50"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-divider class="mt-3 mb-3"></v-divider>
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="Empresa"
                      placeholder="Empresa"                      
                      @change="$v.data.empresa_descricao.$touch()"                      
                      v-model="data.empresa_descricao"
                      persistent-hint hint="Campo obrigatório"
                      maxlength="100"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="CNPJ/CPF"
                      placeholder="CNPJ/CPF"                      
                      @change="$v.data.empresa_cnpj_cpf.$touch()"                      
                      v-model="data.empresa_cnpj_cpf"
                      persistent-hint hint="Campo obrigatório"
                      maxlength="19"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row>

              <!-- <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="Domínio"
                      placeholder="nomeempresa.mczsoft.com"                      
                      @change="$v.data.empresa_domain.$touch()"                      
                      @input="showdomain()"
                      v-model="data.empresa_domain"
                      persistent-hint 
                      :hint="hint_domain"
                      maxlength="19"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row> -->

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="Telefone"
                      placeholder="Telefone"                      
                      persistent-hint hint="Campo obrigatório"
                      v-model="data.empresa_telefone"
                      v-mask="'(##) #####-####'"
                      maxlength="20"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row>

              <!-- <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="Celular"
                      placeholder="Celular"                      
                      @change="$v.data.empresa_celular.$touch()"                      
                      v-model="data.empresa_celular"
                      v-mask="'(##) #####-####'"
                      persistent-hint hint="Campo obrigatório"
                      maxlength="20"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row> -->

              <!-- <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="CEP"
                      placeholder="CEP"                      
                      @change="$v.data.empresa_cep.$touch()"                      
                      v-model="data.empresa_cep"
                      v-mask="'#####-###'"
                      persistent-hint hint="Campo obrigatório"
                      maxlength="9"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row> -->

              <!-- <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="Endereço"
                      placeholder="Endereço"                      
                      @change="$v.data.empresa_endereco.$touch()"                      
                      v-model="data.empresa_endereco"
                      persistent-hint hint="Campo obrigatório"
                      maxlength="100"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="Bairro"
                      placeholder="Bairro"                      
                      @change="$v.data.empresa_bairro.$touch()"                      
                      v-model="data.empresa_bairro"
                      persistent-hint hint="Campo obrigatório"
                      maxlength="50"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row> -->

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="Cidade"
                      placeholder="Cidade"                      
                      @change="$v.data.empresa_cidade.$touch()"                      
                      v-model="data.empresa_cidade"
                      maxlength="50"
                      :disabled="disableForm"
                    ></v-text-field>
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >                  
                    <v-select
                    :items="ufLookup"
                    label="Estado"
                    :disabled="disableForm"
                    v-model="data.empresa_uf"  item-text="label"  item-value="value"
                    @change="$v.data.empresa_uf.$touch()" 
                    ></v-select>
                </v-col>
              </v-row>

              

              <!-- <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-text-field
                      label="País"
                      placeholder="País"                      
                      @change="$v.data.empresa_pais.$touch()"                      
                      v-model="data.empresa_pais"
                    ></v-text-field>
                </v-col>
              </v-row> -->              

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >
                  <v-select
                  :items="planoLookup"
                  label="Plano"
                  :disabled="disableForm"
                  v-model="data.empresa_plano"  item-text="label"  item-value="value"
                  @change="$v.data.empresa_plano.$touch()" 
                  persistent-hint hint="Campo obrigatório"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">              
                <v-col :md="colunas"  >               
                  <v-select
                  :items="fusoLookup"
                  label="Fuso Horário"
                  :disabled="disableForm"
                  v-model="data.empresa_fuso"  item-text="label"  item-value="value"
                  @change="$v.data.empresa_fuso.$touch()" 
                  persistent-hint hint="Campo obrigatório"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row  align="center" justify="center">        
                <v-col :md="colunas" >
                  
                  <v-btn color="primary" width="100%" :disabled="$v.$invalid || $v.$error" type="submit" >    
                      Cadastrar       
                    </v-btn>
                </v-col>
              </v-row>

              
              <v-row  align="center"
                  justify="center">
              
                <v-col              
                  :md="colunas"
                  align="center"
                  justify="center"  
                  class="text-caption"         
                >
                 {{nameApp}} - {{companyDeveloper}} © {{ano}}
                </v-col>
              </v-row>
          <!-- </v-card> -->
             </form>
           </v-container>
        </v-container>
      
  
  </v-main>

  <!-- <v-footer app>
    <! -- -- >
  </v-footer> -->
</v-app>
</template>


<script>


import {required,email} from 'vuelidate/lib/validators';
import axios from 'axios';


export default{
    data(){
        return {
            data: {
              name:'',
              email:'',
              password:'',
              password_again:'',

              empresa_descricao:'',
              empresa_telefone:'',
              empresa_celular:'',
              empresa_endereco:'',
              empresa_bairro:'',
              empresa_cidade:'',
              empresa_uf:'',
              empresa_cep:'',
              empresa_pais:'BRASIL',
              empresa_cnpj_cpf:'',
              empresa_plano:1,
              empresa_fuso:2,
              empresa_domain:""
            },

            colunas: '4',
            planoLookup: [],
            fusoLookup: [],
            ufLookup: [],
            disableForm: true,

            hint_domain: "Crie um endereço exclusivo para sua empresa acessar o sistema. Campo obrigatório. Ex: nomeempresa.mczsoft.com"
        }
    },
    computed: {
        nameApp(){
          return this.$store.getters['app/nameApp'];
        },
        companyDeveloper(){
          return this.$store.getters['app/companyDeveloper'];
        },
        ano(){          
          var d = new Date();
          return d.getFullYear(); 
        } 
    },
    methods:{        
        register(){
            // console.log(this.email);
            // this.$store.dispatch('app/login',{
            //      email: this.email,
            //      password: this.password
            // });
            
            if(this.data.password != this.data.password_again){
              this.$toastr('error',"As senhas devem ser iguais.");
              return;
            }

            if(this.data.password.length < 8){
              this.$toastr('error',"A senha deve ter no mínimo 8 caracteres.");
              return;
            }						
      
            
            if (!this.$v.$error) {		
              axios.post('auth/register', this.data)
                .then( res=>{
                  if( res.data && res.data.success){
                    this.$toastr('success', "Cadastro realizado com sucesso.");
                    this.$toastr('success', "Por favor verique seu email, foi enviado os passos ativar seu cadastro.");
                    this.$router.push({ name: 'login'});
                  } else if(res.data.error) {
                    // console.log('er', res);
                    this.$toastr('error',res.data.error);
                  } else {
                    // console.log('er', res);
                    this.$toastr('error',"Ocorreu algum erro inesperado, verifique os dados informados. Ou contacte-nos pelos email suporte@mczsoft.com");
                  }
                }, () => {
                    // console.log('er2', err);
                    this.$toastr('error',"Ocorreu algum erro inesperado, verifique os dados informados. Ou contacte-nos pelos email suporte@mczsoft.com");
                });
            }else{
              this.$toastr('error',"Informe os dados corretamente.");
            }
        },
        showdomain(){
          if(this.data.empresa_domain.includes("mczsoft.com")){
            this.hint_domain = "erro => retire mczsoft.com, coloque apenas o nome da sua empresa em letras minúsculas.";
          }else if(this.data.empresa_domain.includes("mczsoft")){
            this.hint_domain = "erro => retire mczsoft, coloque apenas o nome da sua empresa em letras minúsculas.";
          }else if(this.data.empresa_domain.includes(".com")){
            this.hint_domain = "erro => retire .com, coloque apenas o nome da sua empresa em letras minúsculas.";
          }else if(this.data.empresa_domain.includes(".")){
            this.hint_domain = "erro => retire o ponto (.) , coloque apenas o nome da sua empresa em letras minúsculas.";
          }else if(this.data.empresa_domain==""){
            this.hint_domain = "Crie um endereço exclusivo para sua empresa acessar o sistema. Campo obrigatório. Ex: nomeempresa.mczsoft.com";
          }else{
            this.hint_domain = "ok => "+this.data.empresa_domain + ".mczsoft.com";
          }
        }
    },
    created(){          
       // console.log('ref',this.$refs);
       // nextTick executa após o DOM se montado, então nesse momento o objeto login existe
       this.$nextTick(() =>  this.$refs.name.focus() );

      this.disableForm = true;
      this.planoLookup = [];
      this.fusoLookup = [];
      this.ufLookup = [];

      const planoLookup = axios.get('auth/register/recuperaplano'); 				
      const fusoLookup = axios.get('auth/register/recuperafuso');
      const ufLookup = axios.get('auth/register/recuperauf');

      axios.all([planoLookup,fusoLookup,ufLookup])
        .then(axios.spread((...responses) => {
          
          const resPlano = responses[0]
          const resFuso = responses[1]
          const resUF = responses[2]
          
          if(resPlano.data && resPlano.data.success && 
            resFuso.data && resFuso.data.success &&
            resUF.data && resUF.data.success){	


            this.planoLookup = resPlano.data.combo;    
            this.fusoLookup = resFuso.data.combo;
            this.ufLookup = resUF.data.enum;
            this.disableForm = false;   

            if(this.$route.query.plano && this.$route.query.plano!='' && this.planoLookup.length>0){        
              for (let plano of this.planoLookup) {
                // console.log(plano.value +'-'+this.$route.query.plano)
                if(plano.value == this.$route.query.plano){
                  this.data.empresa_plano = plano.value;
                  break;
                }
              }              
            }
          }else{                        
            this.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
          }
        })).catch(() => {
          this.$toastr('error',"Ocorreu erro ao carregar os dados, por favor atualize a página.")
        })
      
			
    },
    validations:{
      data:{
        name:{
          required      
        },
        email:{
          required,
          email   
        },
        password:{
          required      
        },
        password_again:{
          required      
        },
        empresa_descricao:{
          required      
        },
        empresa_telefone:{
          required      
        },
        // empresa_celular:{
        //   required      
        // },
        // empresa_endereco:{
        //   required      
        // },
        // empresa_bairro:{
        //   required      
        // },
        // empresa_cidade:{
        //   required      
        // },
        // empresa_uf:{
        //   required      
        // },
        // empresa_cep:{
        //   required      
        // },
        // empresa_pais:{
        //   required      
        // },
        empresa_cnpj_cpf:{
          required      
        },
        empresa_plano:{
          required      
        },
        empresa_fuso:{
          required      
        },
        // empresa_domain:{
        //   required
        // }
      }    
    },
    
}
</script>
